import { ResultStatus, SmsServiceCode } from '@mfe-presentation/constants/userVerification';
import { Portal } from '@aviv-estimation-funnel/estimation-data-models/enums';

import { httpService } from './http';

const WLEF_API_URL = process.env['NX_WLEF_API_URL'];
const WLEF_API_KEY = process.env['NX_WLEF_API_KEY'];

export type SmsServiceCodePayload = [
    {
        code: SmsServiceCode;
    },
];

export type SmsServiceStatusPayload = {
    status: ResultStatus;
};

export interface PhoneNumberValidationResult {
    readonly phoneNumber: string;
    readonly status: ResultStatus;
    readonly phoneNumberVerificationRequestId?: string;
}

export interface PhoneNumberValidationError {
    phoneNumber?: SmsServiceCodePayload | SmsServiceStatusPayload;
    postalCode?: SmsServiceCodePayload;
    ownerObjective?: SmsServiceCodePayload;
    platform?: SmsServiceCodePayload;
    portal?: SmsServiceCodePayload;
}

export interface ValidatePhoneRequestProps {
    ownerObjective: string;
    phoneNumber?: string;
    phoneNumberRegionCode?: string;
    platform: string;
    portal: Portal;
    postalCode: string;
    authorContactDetailsId?: string;
    email?: string;
}

export const validatePhone = async ({
    ownerObjective,
    platform,
    portal,
    postalCode,
    authorContactDetailsId,
    phoneNumber,
    phoneNumberRegionCode,
    email,
}: ValidatePhoneRequestProps): Promise<PhoneNumberValidationResult> => {
    const version = 'v2';
    const { data } = await httpService.post<PhoneNumberValidationResult>(
        `${WLEF_API_URL}/${version}/validations/phone-number`,
        {
            ...(ownerObjective !== '' && { ownerObjective }),
            platform,
            portal,
            postalCode,
            ...(authorContactDetailsId
                ? {
                      authorContactDetailsId,
                      ...(phoneNumber &&
                          phoneNumberRegionCode && { phoneNumber, phoneNumberRegionCode }),
                  }
                : {
                      phoneNumber,
                      phoneNumberRegionCode,
                      email,
                  }),
        },
        {
            headers: {
                'x-api-key': WLEF_API_KEY,
            },
        },
    );
    return data;
};
